// extracted by mini-css-extract-plugin
export default {"button":"CallButton_button__jbtuH","icon":"CallButton_icon__Huq2f"};